export const DELETE_DMX_DEVICE_PRESET = 'DELETE_DMX_DEVICE_PRESET';
export const DELETE_DMX_DEVICE_PRESET_SUCCESSFUL = 'DELETE_DMX_DEVICE_PRESET_SUCCESSFUL';
export const DELETE_DMX_DEVICE_PRESET_FAILED = 'DELETE_DMX_DEVICE_PRESET_FAILED';
